import React from "react";


export const QuestionA3Parts = () => {

    return (
        <>
        <div className="select_desc">福岡県のLPガス販売店と、ご契約いただいていますか？</div>
		<div className="mb-40">※対象店舗は店舗選択画面で確認できます</div>
        </>
    )
}